comparedPath